<template>
  <div :class="['btn-details', type, css]">
    <div
      :title="title || 'Details'"
      class="btn-details-icon"
      @click="onClick"
    ></div>
    <div
      class="btn-details-content"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Details'
    },
    action: {
      type: String,
      default: "details",
      validator: function (value) {
        return [
          "details",
          "expand",
          "modal"
        ].indexOf(value) !== -1
      }
    },
    entity: String,
    entityType: {
      type: String,
      default: 'blankDetails'
    },
    trackHistory: {
      type: Boolean,
      default: false
    },
    args: {
      type: Object,
      default: null
    },
    css: {
      type: String,
      default: ''
    }
  },

  computed: {
    type: function() {
      return 'btn-details-' + this.action;
    }
  },

  methods: {
    onClick: function() {
      if (!this.$attrs.onClick) {
        switch (this.action) {
          case 'details':
            // show details pane by default if there is no @click function on component level
            this.showDetailsPane();
            break;
          case 'expand':
            // expand grid details rows
            this.showDetailsRows();
            break;
          case 'modal':
            this.showModal();
            break;
        }
      }
    },

    showDetailsPane: function() {
      if (vmDetailsPane) {
        vmDetailsPane.$refs.detailsPane.open({
          title: this.title,
          entity: this.entity,
          entityType: this.entityType,
          trackHistory: this.trackHistory,
          args: this.args,
        });

        if (this.$parent.rowRef) {
          app.ui.grid.markRow(JSON.parse(this.$parent.rowRef));
        }
      }
    },

    showDetailsRows: function() {
      if (this.$attrs.onClick) {
        this.$emit('click');
      }
    },
  }
}
</script>